import Scrollbar from 'perfect-scrollbar';

import Component from '../component/component';

import 'perfect-scrollbar/css/perfect-scrollbar.css';
import './perfect-scrollbar.scss';

export default class PerfectScrollbar extends Component {
    static initSelector: string = '.js-perfect-scrollbar';

    scrollbar: Scrollbar;

    constructor(target: HTMLElement) {
        super(target);

        this.scrollbar = new Scrollbar(this.element.get(0), {
            suppressScrollX: this.element.data('hidex'),
            wheelPropagation: true,
        });
    }
}
